import React, { useState } from 'react';
import { Container, Paper, Alert, Snackbar } from '@mui/material';
import { LoginForm } from '../components/auth/LoginForm';
import { RegisterForm } from '../components/auth/RegisterForm';
import { LoginCredentials, RegisterCredentials } from '../types/auth';
import { useAuth } from '../contexts/AuthContext';
import * as authApi from '../api/auth';

export const AuthPage: React.FC = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const { setAuth } = useAuth();

    const handleLogin = async (credentials: LoginCredentials) => {
        try {
            console.log('Handling login in AuthPage');
            const response = await authApi.login(credentials);
            console.log('Login response:', response);
            
            if (!response.user || !response.token) {
                console.error('Invalid login response:', response);
                throw new Error('Invalid login response from server');
            }
            
            console.log('Setting auth with user:', { ...response.user, password: undefined });
            setAuth(response.user, response.token);
        } catch (err) {
            console.error('Login error in AuthPage:', err);
            setError((err as Error).message);
        }
    };

    const handleRegister = async (credentials: RegisterCredentials) => {
        try {
            const response = await authApi.register(credentials);
            if (response.requiresApproval) {
                setSuccessMessage(response.message);
                setIsLogin(true);
            } else {
                setAuth(response.user, response.token);
            }
        } catch (err) {
            setError((err as Error).message);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ p: 4, mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {isLogin ? (
                    <LoginForm 
                        onSubmit={handleLogin} 
                        onToggleForm={() => setIsLogin(false)} 
                    />
                ) : (
                    <RegisterForm 
                        onSubmit={handleRegister} 
                        onToggleForm={() => setIsLogin(true)} 
                    />
                )}
            </Paper>
            <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
                <Alert severity="error" onClose={() => setError(null)}>
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={!!successMessage} autoHideDuration={6000} onClose={() => setSuccessMessage(null)}>
                <Alert severity="success" onClose={() => setSuccessMessage(null)}>
                    {successMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};
